import template from './connectionCompletePopup.html';

class ConnectionCompletePopupController {
    constructor() {
        'ngInject';
    }
}

export const ConnectionCompletePopupComponent = {
    name: 'connectionCompletePopup',
    component: {
        template: template,
        controller: ConnectionCompletePopupController,
        bindings: {
            patient: '<',
            expired: '<',
            onClose: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/connectionCompletePopup.component.js